<template>
  <section class="edit">
    <ul>
      <li v-if="isUser">
        <span @click="deleteThis">{{$t('global.删除')}}</span>
      </li>
      <li>
        <span @click="reportThis">{{$t('global.举报')}}</span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  props: ["isUser", "delete", "report", "id"],
  data() {
    return {};
  },
  methods: {
    deleteThis() {
      if (confirm("确定删除?")) {
        this.$emit("delete", this.id);
      }
    },
    reportThis() {
      this.$emit("report", this.id);
    }
  }
};
</script>

<style lang="stylus" scoped>
.edit {
  ul {
    width: 100px;
    margin-left: -12px;

    li {
      text-align: center;
      cursor: pointer;
      height: 34px;
      line-height: 34px;
      font-weight: 400;
      font-size: 14px;
      color:rgba(51,51,51,1);
      text-align: center;
      &:hover {
        background: #F5F5F5;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/v2/EditOrReport.vue